module.exports = __webpack_public_path__ + "static/bg6.79b4d62f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/bg6.png
// module id = 489
// module chunks = 195485404593854